// MIT © 2017 azu
import { GuideStateArgs, GuideStore } from "../store/GuideStore";

export function updateGuideState(guide: GuideStore, stateArg: GuideStateArgs) {
    guide.update(stateArg);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/action/updateGuideState.ts